import React, { useEffect, useState } from 'react'
import savingIcon from '../../assets/Saving.png';
import savedIcon from '../../assets/saved.png';
import { useCanvas } from '../../context/canvasContext'
import './SavingSaved.css'
import { useDocument } from '../../context/documentInfoContex';
import { Tooltip } from 'antd';

const SavingSaved = () => {
    const { savingData } = useDocument();
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        // <div>
        //     {lastChange() && <div className="SavingSaved">
        //         {lastChange() == 'Saving...' ? (
        //             <img src={savingIcon} alt='Private documnet' style={{ width: '15px', height: '15px', marginRight: 10, marginTop: 4 }} />
        //         ) : <img src={savedIcon} alt='Private documnet' style={{ width: '20px', height: '20px', marginRight: 10 }} />
        //         } <p>
        //             {lastChange()}
        //         </p>
        //     </div>}
        // </div>
        <div className='SavingSaved'>
                       {savingData && (
                <>
                    {savingData.isSaving === 'Saving...' ? (
                        // Show "Saving..." icon and text
                        <>
                            <img
                                src={savingIcon}
                                alt="Saving document"
                                style={{ width: '22px' }}
                            />
                            <span>{savingData.isSaving}</span>
                        </>
                    ) : savingData.isSaving === 'Saved' ? (
                        isSmallScreen ? (
                            // Show tooltip on smaller screens
                            <Tooltip
                                title={
                                    savingData.lastSavedDateTime
                                        ? `${savingData.lastSavedDateTime}, ${savingData.fileSize}`
                                        : savingData.fileSize // If no lastSavedDateTime, only show file size
                                }
                            >
                                <img
                                    src={savedIcon}
                                    alt="Saved document"
                                    style={{ width: '24px', cursor: 'pointer' }}
                                />
                            </Tooltip>
                        ) : (
                            // Show details directly in the header on larger screens
                            <>
                                <img
                                    src={savedIcon}
                                    alt="Saved document"
                                    style={{ width: '24px', cursor: 'default' }}
                                />
                                <span>
                                    {savingData.lastSavedDateTime}
                                    {`, ${savingData.fileSize}`}
                                </span>
                            </>
                        )
                    ) : (
                        // If neither "Saving..." nor "Saved" and fileSize exists, show only the file size
                        savingData.fileSize && <span>{savingData.fileSize}</span>
                    )}
                </>
            )}
        </div>
    )
}

export default SavingSaved;
